/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Button } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  buttonsRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-between",
    },
  },
  primaryButton: {
    marginTop: "1rem",
    color: "#FFFFFF",
    background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
    width: "10rem",
    [theme.breakpoints.down("sm")]: {
      width: "49%",
    },
  },
  secondaryButton: {
    marginTop: "1rem",
    color: "#202020",
    backgroundColor: "#FFFFFF",
    marginRight: "1rem",
    width: "10rem",
    [theme.breakpoints.down("sm")]: {
      width: "49%",
    },
  },
  buttonIcon: {
    margin: "0rem 0.5rem 0rem 0rem",
  },
}));

const PICButtons = (props) => {
  const classes = useStyles();

  const shareButtonClickListener = (event) => {
    event.preventDefault();
    window.location.hash = "#share-" + props.slug;
  };
  const pdfButtonClickListener = (event) => {
    event.preventDefault();
  };

  if (!props.loading) {
    return (
      <React.Fragment>
        <div className={classes.buttonsRow}>
          <Button
            variant="contained"
            title="Share"
            rel="noopener"
            className={classes.secondaryButton}
            onClick={shareButtonClickListener}
          >
            <img
              src="/images/icons/social/share.svg"
              alt={AppConfig.imageAltText}
              width={18}
              height={18}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.buttonIcon}
            />
            Share
          </Button>
          <Button
            variant="contained"
            title="Download"
            rel="noopener"
            className={classes.primaryButton}
            onClick={
              typeof props.pdfButtonClickListener === "function"
                ? props.pdfButtonClickListener
                : pdfButtonClickListener
            }
          >
            <img
              src="/images/icons/social/download-white.svg"
              alt={AppConfig.imageAltText}
              width={18}
              height={18}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.buttonIcon}
            />
            Download
          </Button>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className={classes.buttonsRow}>
          <Skeleton style={{ marginRight: "0.5rem" }}>
            <Button
              variant="contained"
              title="Share"
              rel="noopener"
              className={classes.secondaryButton}
              onClick={shareButtonClickListener}
            >
              <img
                src="/images/icons/social/share.svg"
                alt={AppConfig.imageAltText}
                width={18}
                height={18}
                loading="lazy"
                referrerPolicy="no-referrer"
                className={classes.buttonIcon}
              />
              Share
            </Button>
          </Skeleton>
          <Skeleton style={{ marginLeft: "0.5rem" }}>
            <Button
              variant="contained"
              title="Download"
              rel="noopener"
              className={classes.primaryButton}
              onClick={
                typeof props.pdfButtonClickListener === "function"
                  ? props.pdfButtonClickListener
                  : pdfButtonClickListener
              }
            >
              <img
                src="/images/icons/social/download-white.svg"
                alt={AppConfig.imageAltText}
                width={18}
                height={18}
                loading="lazy"
                referrerPolicy="no-referrer"
                className={classes.buttonIcon}
              />
              Download
            </Button>
          </Skeleton>
        </div>
      </React.Fragment>
    );
  }
};

export default PICButtons;
